module.exports = __webpack_public_path__ + "img/logo.d84eb12d.png";